export default {
  gdpr: {
    disclaimer: {
      marginTop: '15px'
    },
    wrapper: {
      padding: '2em 0px 1em'
    },
    radioButton: {
      display: 'inline-block',
      width: 'auto',
      marginTop: 0,
      marginRight: '1em',
      height: '15px'
    },
    radioButtonWrapper: {
      display: 'flex',
      alignItems: 'center',
      fontWeight: 'normal'
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/ContactUsForm/styles.js